module.exports = __webpack_public_path__ + "img/fws@2x.dd3e9682.png";